import styled from 'styled-components';
import makeStyles from '@mui/styles/makeStyles';

export const BigImage = styled.img`
  height: 400px;
  object-fit: cover;
  width: 610px;
`;
BigImage.displayName = 'BigImage';

export const SmallImage = styled.img`
  cursor: pointer;
  height: 125px;
  margin-bottom: 7px;
  object-fit: cover;
  width: 220px;
`;
SmallImage.displayName = 'SmallImage';

export const Container = styled.div`
  display: flex;
  margin-top: 32px;
`;
Container.displayName = 'Container';

export const useStyles = makeStyles((theme) => ({
  icon: {
    color: theme.palette.text.secondary,
    fontSize: 18,
    marginRight: 8,
  },
  linkIcon: {
    color: theme.palette.info.main,
    fontSize: 20,
    marginRight: 6,
  },
  link: {
    color: theme.palette.info.main,
    '&:hover': {
      cursor: 'pointer',
      textDecoration: 'underline',
    },
  },
}));
